import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import Auth from './components/Auth/Auth';
import Qna from './components/Qna/Qna';
import Home from './components/Home/Home';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { Approved } from './components/Approved/Approved';
import { Rejected } from './components/Rejected/Rejected';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import Profile from './components/Profile/Profile';
import NavBar from './components/NavBar/NavBar';
import { getApiCallable } from "./firebaseModules/apiclient";
import { updateUserDetails } from './reduxModules/userReducer/userActions';
import { Spin } from 'antd';

import './App.css';


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBottomNavBar: false,
      loading: false,
    }
  }
  componentWillReceiveProps = async (nextProps) => {
    if (
      this.props.user !== nextProps.user &&
      !this.props.user &&
      !!nextProps.user
    ) {
      // user logged in
      try {
        this.setState({
          loading: true
        });
        const getUserDetailsCallable = getApiCallable("getUserDetails");
        const res = await getUserDetailsCallable();
        this.props.updateUserDetails(res.data);
        this.setState({
          showBottomNavBar: !!res.data.userDetails,
          redirectToProfilePage: !res.data.userDetails,
          loading: false
        });
      } catch (e) {
        this.setState({
          loading: false
        });
        console.log(e);
      }
    }
    if (
      this.props.userDetails !== nextProps.userDetails &&
      !this.props.userDetails &&
      !!nextProps.userDetails
    ) {
      this.setState({
        showBottomNavBar: true
      });
    }
  }
  isLoggedIn = () => !!this.props.user && !!this.props.user.email;

  authEnabled = (Component) => this.isLoggedIn() ? Component : Auth;

  render () {
    const boolAdminPage = window.location.pathname === '/adminDashboard';
    return (
      <Router>
        {
          this.state.redirectToProfilePage &&
          <Redirect to="/profile" />
        }
        <div className="appContainer">
          {
            this.state.loading &&
            <div className="overlay">
              <Spin />
            </div>
          }
          <div className="component">
            <Switch>
              <Route
                exact
                path="/"
                component={this.authEnabled(Home)}
              />
              <Route
                exact
                path="/auth"
                component={Auth}
              />
              <Route
                exact
                path="/qna"
                component={this.authEnabled(Qna)}
              />
              <Route
                exact
                path="/approved"
                component={this.authEnabled(Approved)}
              />
              <Route
                exact
                path="/rejected"
                component={this.authEnabled(Rejected)}
              />
              <Route
                exact
                path="/adminDashboard"
                component={this.authEnabled(AdminDashboard)}
              />
              <Route
                exact
                path="/profile"
                component={this.authEnabled(Profile)}
              />
            </Switch>
          </div>
          {
            this.state.showBottomNavBar && !boolAdminPage &&
            <NavBar />
          }
        </div>
      </Router>
    );
  }
}

export default connect(
  (state) => ({
    user: state.authReducer.user,
    userDetails: state.userReducer.userDetails
  }),
  (dispatch) => bindActionCreators({ updateUserDetails }, dispatch)
)(App);
